/* DOM homepage: tabs, tampon waitlist toggle */
(function(){
  document.querySelectorAll('.dom-h [role="tablist"]').forEach(function(list){
    var tabs=[].slice.call(list.querySelectorAll('[role="tab"]'));
    function sel(t,f){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on});if(f)t.focus()}
    tabs.forEach(function(t,i){t.addEventListener('click',function(){sel(t)});t.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight')sel(tabs[(i+1)%tabs.length],true);if(e.key==='ArrowLeft')sel(tabs[(i-1+tabs.length)%tabs.length],true)})});
  });
  var b=document.getElementById('tamponWaitBtn'),w=document.getElementById('tampon-wait');
  if(b&&w){b.addEventListener('click',function(e){e.preventDefault();w.hidden=false;b.setAttribute('aria-expanded','true');var i=w.querySelector('input[type=email]');if(i)i.focus()});
    if(w.querySelector('.note'))w.hidden=false;}
})();
